<div class="vertical-menu" *ngIf="menuItems">
  <ng-container *ngFor="let menuItem of menuItems" [ngTemplateOutlet]="menuItemTemplate" [ngTemplateOutletContext]="{ menuItem: menuItem, nestingLevel: 0 }">
  </ng-container >
</div>

<ng-template #menuItemTemplate let-menuItem="menuItem" let-nestingLevel="nestingLevel">
  <div class="flex flex-col user-select-none">
    <div  class="menu-item" [ngClass]="{'selected': menuItem.selected, 'disabled pointer-events-none': menuItem.disabled}" (click)="menuItemClick(menuItem)">
      <div class="flex flex-row" [ngClass]="{'ml-36': nestingLevel > 0}">
        <mat-icon *ngIf="menuItem.icon" [svgIcon]="menuItem.icon" class="icon-md-1 mr-12"></mat-icon>
        <img *ngIf="menuItem.img" [src]="menuItem.img" class="icon-md-1 mr-10">
        <div *ngIf="menuItem.color" class="flex mr-12 mt-8">
          <span class="traffic-light h-10 w-10" [attr.color]="menuItem.color"></span>
        </div>
        <div class="basis-full fw-600 fs-14">
          {{ menuItem.nameKey ? (menuItem.nameKey | transloco) : menuItem.name }}
        </div>
        <mat-icon *ngIf="menuItem.items?.length" [svgIcon]="menuItem.expanded ? 'expand_more': 'chevron_right'"
          class="icon-md-1 ml-12">
        </mat-icon>
      </div>
    </div>
    <div *ngIf="menuItem.items?.length && menuItem.expanded" class="menu-sub-items">
      <ng-container *ngFor="let subMenuItem of menuItem.items" [ngTemplateOutlet]="menuItemTemplate"
        [ngTemplateOutletContext]="{ menuItem: subMenuItem, nestingLevel: nestingLevel + 1 }">
      </ng-container>
    </div>
  </div>
</ng-template>
